import { Stack } from '@chakra-ui/react'
import {
  RiInkBottleLine,
  RiBuilding4Line,
  RiShieldUserLine,
  RiTeamLine,
  RiDashboard2Fill,
  RiBankCardLine,
  RiListCheck,
  RiFileList3Line,
} from 'react-icons/ri'
import { MdAttachMoney } from 'react-icons/md'
import { NavLink } from './NavLink'
import { NavSection } from './NavSection'
import { usePermission } from '../../hooks/usePermission'

const NAV_ITEMS = [
  {
    label: 'Dashboard',
    path: '/dashboard',
    icon: RiDashboard2Fill,
    permissions: ['dashboard.view'],
  },
  {
    label: 'Fornecedores',
    path: '/providers',
    icon: RiBuilding4Line,
    permissions: ['providers.manage'],
  },
  {
    label: 'Matéria prima',
    path: '/raw-materials',
    icon: RiInkBottleLine,
    permissions: ['raw_materials.manage'],
  },
  {
    label: 'Usuários',
    path: '/users',
    icon: RiShieldUserLine,
    permissions: ['users.manage'],
  },
  {
    label: 'Funcionários',
    path: '/employees',
    icon: RiTeamLine,
    permissions: ['employees.manage'],
  },
  {
    label: 'Clientes',
    path: '/clients',
    icon: RiTeamLine,
    permissions: ['clients.manage'],
  },
  {
    label: 'Pedidos',
    path: '/demands',
    icon: MdAttachMoney,
    permissions: ['demands.manage'],
  },
  {
    label: 'Financeiro',
    path: '/financial',
    icon: MdAttachMoney,
    permissions: ['financial.manage'],
  },
  {
    label: 'Formas de pagamento',
    path: '/payment-methods',
    icon: RiBankCardLine,
    permissions: ['financial.manage'],
  },
  {
    label: 'Condições de pagamento',
    path: '/payment-conditions',
    icon: RiListCheck,
    permissions: ['financial.manage'],
  },
  {
    label: 'Contas em aberto',
    path: '/open-accounts',
    icon: RiFileList3Line,
    permissions: ['financial.manage'],
  },
  {
    label: 'Gerenciador de estoque',
    path: '/stock-management',
    icon: RiInkBottleLine,
    permissions: ['stock.manage'],
  },
]

export function SidebarNav() {
  const { hasPermission } = usePermission()

  const visibleItems = NAV_ITEMS.filter((item) => hasPermission(item.permissions))

  return (
    <Stack spacing="12" align="flex-start">
      <NavSection title="GERAL">
        {visibleItems.map((item) => (
          <NavLink key={item.path} icon={item.icon} path={item.path}>
            {item.label}
          </NavLink>
        ))}
      </NavSection>
    </Stack>
  )
}
